import axios from 'axios'
import { responseHandler, apiErrorHandler } from '../actions/handlers.action'
import { showNotification } from '../actions/notification.action'
import { paginationValue, STATEROOM_FILTER_STATUS } from '../../src/constants'

import { postStateroomDataAction, getGuestTypeDataAction, getStateroomCapacityAction, postStateroomStatusDataAction, getStateroomCategoryAction, postStateroomSearchDataAction, postStateroomFilterDataAction } from '../actions/stateroom.action'

import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import { LIST_STATEROOM_QUERY } from '../graphql/queries/guestQueries'
import { queryResolver } from '../helpers/gqlUtil'

export const poststateroomData = () => (dispatch, getState) => {
  const state = getState()
  const shipDetails = get(state.masterdata, 'shipDetails', {})
  const body = {
    shipCode: shipDetails.shipCode
  }

  return axios
    .post(`${get(state, 'startup.stateroomsListURL')}?page=1&size=99999`, body)
    .then(response => {
      responseHandler(dispatch, response, postStateroomDataAction)
      return response
    })
    .catch(error => {
      apiErrorHandler(dispatch, error)
    })
}
export const getStateroomCategory = (isGuestDetailsPage) => (dispatch, getState) => {
  const state = getState()
  const shipDetails = get(state.masterdata, 'shipDetails', {})
  return axios
    .get(isGuestDetailsPage?`${get(state, 'startup.getStateroomCategoryURL')}?shipCode=${shipDetails.shipCode}&excludeCrewCabins=true`:`${get(state, 'startup.getStateroomCategoryURL')}?shipCode=${shipDetails.shipCode}`)
    .then(response => {
      responseHandler(dispatch, response, getStateroomCategoryAction)
      return response
    })
    .catch(error => {
      apiErrorHandler(dispatch, error)
    })
}
export const getStateroomCapacity = () => (dispatch, getState) => {
  const state = getState()
  const shipDetails = get(state.masterdata, 'shipDetails', {})

  return axios
    .get(`${get(state, 'startup.getStateroomCapacityURL')}?shipCode=${shipDetails.shipCode}`)
    .then(response => {
      responseHandler(dispatch, response, getStateroomCapacityAction)
      return response
    })
    .catch(error => {
      apiErrorHandler(dispatch, error)
    })
}

export const getGuestType = () => (dispatch, getState) => {
  const state = getState()
  return axios
    .get(`${get(state, 'startup.guesttypesUrl')}?size=99999`)
    .then(response => {
      responseHandler(dispatch, response, getGuestTypeDataAction)
      return response
    })
    .catch(error => {
      apiErrorHandler(dispatch, error)
    })
}

export const stateroomSearchData = ({
  pageCount = 1,
  filterObj = {},
  sort = 'stateroom',
  order = 'asc'
} = {}) => (dispatch, getState) => {
  const state = getState()
  const shipDetails = get(state.masterdata, 'shipDetails', {})
  const voyageNumber = get(state, 'voyage.voyageNumber')
  const pageSort = { field: sort, direction: order.toUpperCase() }
  const pageFilter = {
    size: paginationValue.defaultPageSize,
    page: pageCount
  }

  const filter = {
    includeReservationNumber: true,
    shipCode: shipDetails.shipCode,
    voyageFilter: {
      voyageNumber
    },
    stateRoomFilter: {
      staterooms: filterObj.staterooms,
      excludeCrewCabins: false
    }
  }

  return queryResolver({
    query: LIST_STATEROOM_QUERY,
    variables: {
      filter,
      pageFilter,
      pageSort
    }
  })
    .then(response => {
      const page = get(response, 'data.searchStaterooms.pageInfo', [])
      const mappedStateroom = get(
        response,
        'data.searchStaterooms.staterooms',
        []
      )
      responseHandler(
        dispatch,
        { page, _embedded: { staterooms: mappedStateroom } },
        postStateroomSearchDataAction
      )
      return response
    })
    .catch(error => {
      apiErrorHandler(dispatch, error)
    })
}

export const postStateroomSearchData = ({ pageCount = 1, excludeCrewCabins, statusUpdated, isDownload = false, isSortedClicked=false,filterObj = {}, isFilter = false, page = '',sort='stateroom',order ='asc'} = {}) => (dispatch, getState) => {
  const state = getState()
  const shipDetails = get(state.masterdata, 'shipDetails', {})
  const voyageNumber = get(state, 'voyage.voyageNumber')
  let body = {
    shipCode: shipDetails.shipCode,
    includeReservationNumber: true,
    voyageNumber: voyageNumber
  }
  if(excludeCrewCabins){
    body.excludeCrewCabins=true
  }
  else{
    body.excludeCrewCabins=false
  }
 
  let updatedFilterObject = JSON.parse(JSON.stringify(filterObj))
  for (let key in updatedFilterObject) {
    if (key !== 'isVacant' && isEmpty(get(updatedFilterObject, key))) {
      delete updatedFilterObject[key]
    }
  }

  if (!isEmpty(filterObj.roomStatuses)) {
    let isOccupiedStatusIndex = filterObj.roomStatuses.findIndex(checkedRooms => checkedRooms === STATEROOM_FILTER_STATUS.occupied)
    let isAvailableStatus = filterObj.roomStatuses.find(checkedRooms => checkedRooms === STATEROOM_FILTER_STATUS.available)
    if (isOccupiedStatusIndex >= 0){
      updatedFilterObject.roomStatuses.splice(isOccupiedStatusIndex)
      if (!isAvailableStatus) {
        updatedFilterObject.roomStatuses.push(1)
      }
    }
  }
  let actionCreator = postStateroomSearchDataAction
  body = { ...body, ...updatedFilterObject }
  if (isFilter || statusUpdated || isSortedClicked) {
    actionCreator = postStateroomFilterDataAction
  }

  let url = ''
  if (isDownload || page === 'newReservation') {
    url = `${get(state, 'startup.stateroomsSearchURL')}/v1?page=1&size=99999`
  }
  else{
    url = `${get(state, 'startup.stateroomsSearchURL')}/v1?sort=${sort}:${order}&page=${pageCount}` 
  }
  return axios
    .post(url, body)
    .then(response => {
      if (!isDownload) {
        responseHandler(dispatch, response, actionCreator)
      }
      return response
    })

    .catch(error => {
      apiErrorHandler(dispatch, error)
    })
}

export const postStateroomStatusData = (rooms, status) => (dispatch, getState) => {
  const state = getState()
  const shipDetails = get(state.masterdata, 'shipDetails', {})
  const body = {
    shipCode: shipDetails.shipCode,
    staterooms: rooms,
    roomStatus: status

  }
  return axios
    .post(`${get(state, 'startup.postStateroomStatusUpdateURL')}`, body)
    .then(response => {
      if (response.status === 200) {
        dispatch(
          showNotification({
            class: 'is-success',
            message: 'Stateroom status is successfully updated.'
          })
        )
      } else {
        dispatch(
          showNotification({
            class: 'is-danger',
            message: 'Oops! Some technical issue occured. Please try again.'
          })
        )
      }
      responseHandler(dispatch, response, postStateroomStatusDataAction)
      return response
    })
    .catch(error => {
      apiErrorHandler(dispatch, error)
    })
}
